import { FilterTypes } from "@lib/constants/filtersConstants";

type FilterOption = { value?: string };

const isTrueOnlyFilter = (filterType?: string): boolean =>
    filterType === FilterTypes.commonTrueOnly;

export const getVisibleFilterOptions = <Option extends FilterOption>(
    options: Option[],
    filterType?: string
): Option[] =>
    isTrueOnlyFilter(filterType) ? options.filter((option) => option.value === "true") : options;

export const hasVisibleFilterOptions = (
    options: FilterOption[] | undefined,
    filterType?: string
): boolean =>
    isTrueOnlyFilter(filterType)
        ? getVisibleFilterOptions(options ?? [], filterType).length > 0
        : (options?.length ?? 0) > 1;
